/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.flexbox-for-WarningImage[_ngcontent-%COMP%]\r\n{\r\n    display: -webkit-box;\r\n    display: -ms-flexbox;\r\n    display: flex;\r\n    gap: 90px;\r\n}\r\n.flexconatiner-for-Image[_ngcontent-%COMP%]\r\n{\r\n    height: 115px;\r\n    width: 300px;\r\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiQzovVXNlcnMvTlJFR0UzL1dvcmtzcGFjZS9PblByZW1DaGluYS9QYWNrSVRXZWJHdWkvc3JjL2FwcC9pbWFnZS13YXJuaW5nLWJlZm9yZS11cGxvYWQvaW1hZ2Utd2FybmluZy1iZWZvcmUtdXBsb2FkLmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vQzovVXNlcnMvTlJFR0UzL1dvcmtzcGFjZS9PblByZW1DaGluYS9QYWNrSVRXZWJHdWkvc3JjL2FwcC9pbWFnZS13YXJuaW5nLWJlZm9yZS11cGxvYWQvaW1hZ2Utd2FybmluZy1iZWZvcmUtdXBsb2FkLmNvbXBvbmVudC5jc3MiXSwic291cmNlc0NvbnRlbnQiOlsiICJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7OyJ9



// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/$$_gendir/app/image-warning-before-upload/image-warning-before-upload.component.css.shim.ngstyle.ts